import React from "react";
import Snap from "snapsvg-cjs";
import classie from "desandro-classie";
import packageJson from "../../../package.json";

function SVGMenu(el, options) {
  this.el = el;
  this.init();
}

SVGMenu.prototype.init = function() {
  this.trigger = this.el.querySelector("button.menu__handle");
  this.shapeEl = this.el.querySelector("div.morph-shape");

  var s = Snap(this.shapeEl.querySelector("svg"));
  this.pathEl = s.select("path");
  this.paths = {
    reset: this.pathEl.attr("d"),
    open: this.shapeEl.getAttribute("data-morph-open"),
    close: this.shapeEl.getAttribute("data-morph-close")
  };

  this.isOpen = false;

  this.initEvents();
};

SVGMenu.prototype.initEvents = function() {
  this.trigger.addEventListener("click", this.toggle.bind(this));
};

SVGMenu.prototype.toggle = function() {
  var self = this;

  if (this.isOpen) {
    classie.remove(self.el, "menu--anim");
    setTimeout(function() {
      classie.remove(self.el, "menu--open");
    }, 250);
  } else {
    classie.add(self.el, "menu--anim");
    setTimeout(function() {
      classie.add(self.el, "menu--open");
    }, 250);
  }
  this.pathEl
    .stop()
    .animate(
      { path: this.isOpen ? this.paths.close : this.paths.open },
      350,
      window.mina.easeout,
      function() {
        self.pathEl
          .stop()
          .animate({ path: self.paths.reset }, 800, window.mina.elastic);
      }
    );

  this.isOpen = !this.isOpen;
};

export default class Sidebar extends React.Component {
  static defaultProps = { color: "#847b84" };

  componentDidMount() {
    let element = this.svgSidebar;
    new SVGMenu(element);
  }

  logout = () => {
    // remove token from local storage and reload page to reset apollo client
    localStorage.removeItem("graphcoolToken");
    window.location.reload();
  };

  render() {
    const { role } = this.props;
    //  ref={d => (this.svgDiv = d)}
    let sidebar = (
      <nav id="menu" className="menu" ref={d => (this.svgSidebar = d)}>
        <button className="menu__handle">
          <span>Menu</span>
        </button>
        <p className="menu-label">{this.props.name}:</p>
        <div className="menu__inner">
          <ul className="menu-list">
            <li>
              <a href="/" className="is-active">
                Calendrier
              </a>
            </li>
            <li>
              <a href="/patients">Patients</a>
            </li>
            {role === "DOCTOR" ? (
              <li>
                <a href="/options">Options</a>
              </li>
            ) : null}

            <li>
              <a onClick={this.logout}>Déconnecter</a>
            </li>
          </ul>
          <span className="version">{packageJson.version}</span>
        </div>
        <div
          className="morph-shape"
          data-morph-open="M300-10c0,0,295,164,295,410c0,232-295,410-295,410"
          data-morph-close="M300-10C300-10,5,154,5,400c0,232,295,410,295,410"
        >
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 600 800"
            preserveAspectRatio="none"
          >
            <path fill="none" d="M300-10c0,0,0,164,0,410c0,232,0,410,0,410" />
          </svg>
        </div>
      </nav>
    );

    return sidebar;
  }
}



// WEBPACK FOOTER //
// ./src/components/utilities/Sidebar.js